export const addAHeading = {
  rootId: 'f2d33316-8857-4496-a0c7-3dcc9c4ff981',
  layers: {
    'f2d33316-8857-4496-a0c7-3dcc9c4ff981': {
      type: { resolvedName: 'TextLayer' },
      props: {
        text: '<p style="text-align: center;font-family: Roboto;font-size: 68px;color: rgb(0, 0, 0);line-height: 1.4;letter-spacing: 0em;"><strong><span style="color: rgb(0, 0, 0);">Add a heading</span></strong></p>',
        position: { x: 525.12102340009, y: 261.582179409994 },
        boxSize: {
          width: 536.3009995574356,
          height: 95,
          x: 523.1390728476821,
          y: 259.9867549668875,
        },
        scale: 1,
        rotate: 0,
        fonts: [
          {
            name: 'Roboto',
            fonts: [
              {
                style: 'Bold',
                urls: [
                  'https://lidojs-fonts.s3.us-east-2.amazonaws.com/Roboto/Roboto-Bold.woff2',
                ],
              },
              {
                style: 'Bold_Italic',
                urls: [
                  'https://lidojs-fonts.s3.us-east-2.amazonaws.com/Roboto/Roboto-Bold.woff2',
                ],
              },
              {
                style: 'Bold',
                urls: [
                  'https://lidojs-fonts.s3.us-east-2.amazonaws.com/Roboto/Roboto-Bold.woff2',
                ],
              },
              {
                urls: [
                  'https://lidojs-fonts.s3.us-east-2.amazonaws.com/Roboto/Roboto-Regular.woff2',
                ],
              },
              {
                style: 'Italic',
                urls: [
                  'https://lidojs-fonts.s3.us-east-2.amazonaws.com/Roboto/Roboto-Regular.woff2',
                ],
              },
              {
                urls: [
                  'https://lidojs-fonts.s3.us-east-2.amazonaws.com/Roboto/Roboto-Regular.woff2',
                ],
              },
            ],
          },
        ],
        colors: ['rgb(0, 0, 0)'],
        fontSizes: [68],
      },
      locked: false,
      child: [],
      parent: 'ROOT',
    },
  },
};

export const addASubheading = {
  rootId: '9cc89a8c-49d5-4f90-9964-f65bbe90db92',
  layers: {
    '9cc89a8c-49d5-4f90-9964-f65bbe90db92': {
      type: { resolvedName: 'TextLayer' },
      props: {
        text: '<p style="text-align: center;font-family: Roboto;font-size: 38px;color: rgb(0, 0, 0);line-height: 1.4;letter-spacing: 0em;"><strong><span style="color: rgb(0, 0, 0);">Add a subheading</span></strong></p>',
        position: { x: 519.12102340009, y: 365.582179409994 },
        boxSize: {
          width: 536.3009995574356,
          height: 53,
          x: 523.1390728476821,
          y: 259.9867549668875,
        },
        scale: 1,
        rotate: 0,
        fonts: [
          {
            name: 'Roboto',
            fonts: [
              {
                style: 'Bold',
                urls: [
                  'https://lidojs-fonts.s3.us-east-2.amazonaws.com/Roboto/Roboto-Bold.woff2',
                ],
              },
              {
                style: 'Bold_Italic',
                urls: [
                  'https://lidojs-fonts.s3.us-east-2.amazonaws.com/Roboto/Roboto-Bold.woff2',
                ],
              },
              {
                style: 'Bold',
                urls: [
                  'https://lidojs-fonts.s3.us-east-2.amazonaws.com/Roboto/Roboto-Bold.woff2',
                ],
              },
              {
                urls: [
                  'https://lidojs-fonts.s3.us-east-2.amazonaws.com/Roboto/Roboto-Regular.woff2',
                ],
              },
              {
                style: 'Italic',
                urls: [
                  'https://lidojs-fonts.s3.us-east-2.amazonaws.com/Roboto/Roboto-Regular.woff2',
                ],
              },
              {
                urls: [
                  'https://lidojs-fonts.s3.us-east-2.amazonaws.com/Roboto/Roboto-Regular.woff2',
                ],
              },
            ],
          },
        ],
        colors: ['rgb(0, 0, 0)'],
        fontSizes: [38],
      },
      locked: false,
      child: [],
      parent: 'ROOT',
    },
  },
};

export const addABodyText = {
  rootId: '3cace409-216f-4e0e-9449-9248901c8c94',
  layers: {
    '3cace409-216f-4e0e-9449-9248901c8c94': {
      type: { resolvedName: 'TextLayer' },
      props: {
        text: '<p style="text-align: center;font-family: Roboto;font-size: 26px;color: rgb(0, 0, 0);line-height: 1.4;letter-spacing: 0em;"><span style="color: rgb(0, 0, 0);">Add a little bit of body text</span></p>',
        position: { x: 508.99988653474736, y: 434.903672486454 },
        boxSize: {
          width: 536.3009995574356,
          height: 36,
          x: 523.1390728476821,
          y: 259.9867549668875,
        },
        scale: 1,
        rotate: 0,
        fonts: [
          {
            name: 'Roboto',
            fonts: [
              {
                style: 'Bold',
                urls: [
                  'https://lidojs-fonts.s3.us-east-2.amazonaws.com/Roboto/Roboto-Bold.woff2',
                ],
              },
              {
                style: 'Bold_Italic',
                urls: [
                  'https://lidojs-fonts.s3.us-east-2.amazonaws.com/Roboto/Roboto-Bold.woff2',
                ],
              },
              {
                style: 'Bold',
                urls: [
                  'https://lidojs-fonts.s3.us-east-2.amazonaws.com/Roboto/Roboto-Bold.woff2',
                ],
              },
              {
                urls: [
                  'https://lidojs-fonts.s3.us-east-2.amazonaws.com/Roboto/Roboto-Regular.woff2',
                ],
              },
              {
                style: 'Italic',
                urls: [
                  'https://lidojs-fonts.s3.us-east-2.amazonaws.com/Roboto/Roboto-Regular.woff2',
                ],
              },
              {
                urls: [
                  'https://lidojs-fonts.s3.us-east-2.amazonaws.com/Roboto/Roboto-Regular.woff2',
                ],
              },
            ],
          },
        ],
        colors: ['rgb(0, 0, 0)'],
        fontSizes: [26],
      },
      locked: false,
      child: [],
      parent: 'ROOT',
    },
  },
};
